// Recording-check screen.
//
// Structured, because the prose version said everything twice: three numbered
// instructions ("Start a recording", "Share your entire screen", "Turn your camera on")
// followed by three checkboxes that restated them ("My recording has started", "I am
// sharing my entire screen"…). Merging them makes each instruction its own tick — read
// the row, do it, tick it, move down. One pass instead of two.
//
// Replaces the one stale assumption in M0/P0, which were written for a live proctored
// call ("join the Zoom link"). Self-started recordings, reviewed afterwards.

export const RECORDING_STEPS = [
  {
    key: 'recording',
    action: 'Start a recording',
    detail: 'Zoom works — start a meeting on your own, nobody else needs to join. Or any screen recorder you already have.'
  },
  {
    key: 'fullscreen',
    action: 'Share your entire screen',
    // The one failure that silently destroys the evidence, so it gets the why.
    detail: 'Not just this browser tab — a tab-only recording doesn’t show the part we need.'
  },
  {
    key: 'camera',
    action: 'Turn your camera on',
    detail: 'Check you’re visible in the recording.'
  }
]

export const RECORDING_LEAD = {
  main: 'This session is recorded so we can confirm the on-your-own parts were done on your own. You start it yourself and stop it at the end.',
  followup: 'Same setup as last time. You start the recording yourself and stop it at the end.'
}

// Main session has no tail — "leave it running, stop at the end" is the default
// expectation of starting a recording, and saying so bought nothing.
// The follow-up keeps one, because it carries the no-AI rule for that day's task,
// which is not a restatement of anything.
export const RECORDING_TAIL = {
  main: null,
  followup: 'Today’s task is done without AI, web search, notes or other people — the Trio documentation link is available.'
}

export const RECORDING_REF_LABEL = 'Recording reference'
// Asked for now rather than afterwards: a Zoom meeting ID exists the moment the meeting
// starts, whereas a cloud recording link doesn't appear until processing finishes.
export const RECORDING_REF_HELP = 'Your Zoom meeting ID, or the filename you saved it as — so we can match the recording to your session.'
